import { Box, HStack, IconStatusNew, Text, VStack } from '@genial/components';
import { BoxRadius } from '@genial/design-tokens';
import React from 'react';

import { FixedFeeTermHistoryItem } from '../../../../../../../store/fixedFee/types';
import {
  ColoredSkeleton,
  TextSkeleton,
} from '../../../../../../BatchTicket/components/DynamicAsset/components/AssetsLoading';
import { Observations } from '../../../../../components/FixedFeeTermsSection/components/FixedFeeTermsList/components/shared/Observations';

interface TimelineItemProps extends FixedFeeTermHistoryItem {
  isDimmed: boolean;
}

const TimelineItem: React.FC<TimelineItemProps> = ({
  term,
  termStatus,
  termStatusIcon,
  termStatusColor,
  channelStatus,
  channelStatusIcon,
  channelStatusColor,
  eventLabel,
  observation,
  isDimmed,
}) => {
  const textColor = isDimmed ? 'neutral.light' : 'neutral.medium';

  return (
    <HStack space="inline.nano" alignItems="flex-start">
      <VStack mt="2px" space="stack.nano" h="full">
        <Box
          w="16px"
          h="16px"
          alignItems="center"
          justifyContent="center"
          borderWidth="1px"
          borderRadius="full"
          borderColor={isDimmed ? 'neutral.light' : 'brand.primary.principal'}>
          {!isDimmed && (
            <Box
              w="10px"
              h="10px"
              borderWidth="1px"
              borderRadius="full"
              borderColor="brand.primary.principal"
              bg="brand.primary.principal"
            />
          )}
        </Box>
        <Box
          flex={1}
          height="full"
          ml="8px"
          borderStyle="dashed"
          borderLeftWidth="1px"
          borderColor="neutral.lightest"
        />
      </VStack>

      <VStack flex={1} space="stack.nano">
        <HStack justifyContent="space-between" alignItems="center" space="inline.nano">
          <Text variant="semibold" color={textColor}>
            {term}
          </Text>
          <IconStatusNew
            color={isDimmed ? 'neutral.light' : termStatusColor}
            status={termStatus}
            icon={termStatusIcon}
          />
        </HStack>

        <HStack justifyContent="space-between" alignItems="center" space="inline.nano">
          <Text color={textColor} fontSize="sm">
            Última atualização do canal
          </Text>
          <IconStatusNew
            color={isDimmed ? 'neutral.light' : channelStatusColor}
            status={channelStatus}
            icon={channelStatusIcon}
          />
        </HStack>

        <HStack justifyContent="space-between" alignItems="center" space="inline.nano">
          <Text color={textColor} fontSize="sm">
            Evento
          </Text>
          <Text color={textColor} fontSize="sm">
            {eventLabel}
          </Text>
        </HStack>

        <HStack justifyContent="space-between" alignItems="center" space="inline.nano">
          <Text color={textColor} fontSize="sm">
            Observação
          </Text>
          <Observations observations={observation} textProps={{ color: textColor }} />
        </HStack>
      </VStack>
    </HStack>
  );
};

export const TimelineItemMemo = React.memo(TimelineItem);

export const TimelineItemLoading: React.FC = () => {
  return (
    <HStack space="inline.nano" alignItems="flex-start">
      <ColoredSkeleton width="inline.xxs" height="stack.xxs" borderRadius={BoxRadius.circular} />

      <VStack flex={1} space="stack.quarck">
        <TextSkeleton w="25%" />

        <HStack justifyContent="space-between" alignItems="center" space="inline.nano">
          <TextSkeleton w="36%" />
          <TextSkeleton w="18%" />
        </HStack>

        <HStack justifyContent="space-between" alignItems="center" space="inline.nano">
          <TextSkeleton w="18%" />
          <TextSkeleton w="30%" />
        </HStack>

        <HStack justifyContent="space-between" alignItems="center" space="inline.nano">
          <TextSkeleton w="24%" />
          <TextSkeleton w="34%" />
        </HStack>
      </VStack>
    </HStack>
  );
};
